import { settings } from './cart-utils';

export class Cart {
  constructor() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.getCart = this.getCart.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.updateCartTriggerState = this.updateCartTriggerState.bind(this);
    this.add = this.add.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.updateCartNote = this.updateCartNote.bind(this);
    this.build = this.build.bind(this);
    this.buildVariantOptionsWithValues = this.buildVariantOptionsWithValues.bind(this);
    this.buildVariantTitle = this.buildVariantTitle.bind(this);
    this.buildVariantProperties = this.buildVariantProperties.bind(this);
    this.optimizeImageUrl = this.optimizeImageUrl.bind(this);
    this.hasItems = this.hasItems.bind(this);
    this.getItemsCount = this.getItemsCount.bind(this);
    this.toggle = this.toggle.bind(this);
    this.appendCartHtml = this.appendCartHtml.bind(this);
    this.buildItem = this.buildItem.bind(this);
    this.buildItemsHtml = this.buildItemsHtml.bind(this);
    this.buildCartSavings = this.buildCartSavings.bind(this);
    this.initCartDrawer = this.initCartDrawer.bind(this);
    this.buildCart = this.buildCart.bind(this);
    this.updateShippingText = this.updateShippingText.bind(this);

    this.settings = settings;

    this.isCartBuilded = false;
    this.isCartDrawerOpen = false;

    $(document).on(
      'click',
      this.settings.selectors.cartToggleTrigger,
      $.proxy(function(event) {
        event.preventDefault();

        this.toggle();
      }, this)
    );

    $(document).on(
      'click',
      this.settings.selectors.sumbitCart,
      $.proxy(function(event) {
        event.preventDefault();
        const targetTextArea = document.querySelector('.form__row.cart-drawer__note #CartNote');
        const note = targetTextArea.value;
        this.updateCartNote({note});
      }, this)
    );
  }

  /**
   * Get the cart and build it
   * @return {Void}
   */

  getCart() {
    fetch('/cart?view=json')
    .then(res=>res.json())
    .then((cart)=>{
      console.log('cart', JSON.parse(JSON.stringify(cart.items)));
      this.build(cart);
    })
    .catch((err)=>{
      console.error(err.message, err);
    });
  }

  /**
   * Add item(s) to the cart and build it
   * @param {Array} items - An array holding the object(s) with item properties.
   *                      - More info: https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   * @return {Void}
   */

  add(items) {
    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { items },
      success(item) {
        this.getCart();
        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);
      },
      error(err) {
        alert(err.responseJSON.description);
        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);
      },
    });
  }

  /**
   * Update/Remove item from the cart
   * @param  {Integer} quantity - Quantity of the updated item. 0 for item removal.
   * @param  {Integer} id - The KEY of the line item.
   * @param  {Object}  properties - Properties of the line item.
   * @param  {isCartPage}  isCartPage - Use it to build the cart page or the cart drawer.
   * @return {Void}
   */

  updateItem(quantity, id, properties = {}, isCartPage = false) {
    $.ajax({
      url: '/cart/change.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { quantity, id, properties },
      success() {
        this.getCart();
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Update cart order notes
   * @param {Object} note - An object with a key 'note' and note content to be updated.
   *                      - More info: https://shopify.dev/api/ajax/reference/cart#post-cart-update-js
   * @return {Void}
   */

  updateCartNote(note) {
    $.ajax({
      url: '/cart/update.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: note,
      success() {
        window.location.href = '/checkout';
      },
      error(err) {
        console.log('> cart note error', err.responseJSON.description);
        window.location.href = '/cart';
      },
    });
  }

  /**
   * Build item variant options with values, if available
   * @param  {Object} item - The item JSON
   * @return {String}
   */

  buildVariantOptionsWithValues(item) {
    const hasVariants = item.options_with_values.length && item.options_with_values[0].value !== 'Default Title';
    let variantsHtml = '';

    if (hasVariants) {
      item.options_with_values.forEach((option) => {
        let template = this.settings.templates.cartDrawerItemVariants;
        template = template.replace(/{{optionName}}/g, option.name);
        template = template.replace(/{{optionValue}}/g, option.value);

        variantsHtml += template;
      });
    }

    return variantsHtml;
  }

  /**
   * Build variant title, based on options
   * @param  {Object} item - The item JSON
   * @return {String}
   */

  buildVariantTitle(item) {
    const hasVariants = item.options_with_values.length && item.options_with_values[0].value !== 'Default Title';
    let variantsHtml = '';

    if (hasVariants) {
      variantsHtml = this.settings.templates.cartPageItemVariants;
      variantsHtml = variantsHtml.replace(/{{itemVariantTitle}}/g, item.variant_title);
    }

    return variantsHtml;
  }

  /**
   * Build item properties, if available
   * @param  {Object} item - The item
   * @param  {String} template - The item template
   * @return {String}
   */

  buildVariantProperties(item, template) {
    if(item.vendor?.toLowerCase() == 'extend') { return ""; }

    const hasProperties = item.properties !== null && item.properties !== {};
    let propertiesHtml = '';

    if (hasProperties) {
      Object.keys(item.properties).forEach((key) => {
        let html = template;

        html = html.replace(/{{propertyKey}}/g, key);
        html = html.replace(
          /{{propertyKeyValue}}/g,
          item.properties[key]?.indexOf('/uploads/') !== -1
            ? `<a href="${item.properties[key]}">${item.properties[key].split('/uploads/')[1]}</a>`
            : item.properties[key]
        );
        propertiesHtml += html;
      });
    }

    return propertiesHtml;
  }

  /**
   * Build cart/cart drawer
   * @param  {Object}  cart       - The cart JSON
   * @param  {Boolean} isCartPage - Determines what to build - Cart drawer or cart page
   * @return {Void}
   */

  build(cart, isCartPage = false) {
    this.updateCounter(this.getItemsCount(cart));
    this.updateCartTriggerState(this.getItemsCount(cart));

    if (!this.hasItems(cart)) {
      const template = isCartPage ? this.settings.templates.cartPageItemsHolderEmpty : this.settings.templates.cartDrawerEmpty;

      this.buildCart(cart, template, isCartPage);
      this.updateShippingText(cart);

      return;
    }

    const template = isCartPage ? this.settings.templates.cartPageItemsHolder : this.settings.templates.cartDrawer;
    const itemsHtml = this.buildItemsHtml(cart.items, isCartPage);

    this.buildCart(cart, template, isCartPage, itemsHtml);
    this.loyaltyLionUIRefresh();
    //Extend — Normalize cart on update
    requestAnimationFrame(()=>{
      window.dispatchEvent(new Event("refreshAjaxCart"));
      window.dispatchEvent(new Event("refreshAjaxSideCart"));
    });
    //Extend - End Extend code
  }

  /**
   * Build cart elements
   * @param  {Object}  cart       - The JSON of the cart
   * @param  {String}  html       - The cart template
   * @param  {Boolean} isCartPage
   * @param  {String}  itemsHtml  - Items HTML
   * @return {Void}
   */

  buildCart(cart, template, isCartPage = false, itemsHtml = '') {
    const $holder = isCartPage ? $(this.settings.selectors.cartHolder) : $(this.settings.selectors.cartDrawer);

    if (itemsHtml !== '') {
      let saleItems = cart.items.filter((item)=>{
        return item.compare_at_price > item.price ||

          item.product_tags.find((tag)=>{
            tag = tag.toLowerCase();
            console.log('tag', tag)
            return tag == 'sale' || tag == 'open box';
          }) ||

          window.enableSaleEvent && (
            item.product_tags.find((tag)=>{
              tag = tag.toLowerCase();
              let tagSplit = tag.split('bfcm');
              return (tagSplit[0] == '' && +tagSplit[1] > 0 ) && tag.indexOf('-') == -1;
            })
            );
      });
      // console.log('saleItems', saleItems);
      let warrantyitems = cart.items.filter((item)=>{return item.vendor.toLowerCase().indexOf('extend') !== -1});
      let saleItemsIds = saleItems.map((item)=>{ return item.id });
      let warrantyLinkProductIds = warrantyitems.map((item)=>{
          return Object.entries(item.properties).filter(([key,value])=>{
            if (key.toLowerCase().indexOf('productid') !== -1) {
              return value;
            }
          }).map((item)=>{
            //map productid property value
            return +item[1];
          })
        }).reduce((prev, cur) => {
          //reduce array of arrays into single array
          return prev.concat(cur);
        }, []).filter((id)=>{
          // remove warrentyLinkProduct if it is also a sale product
          return saleItemsIds.indexOf(id) == -1});

      let excludedItems = saleItems.concat(warrantyitems);
      // console.log('excludedItems', excludedItems);
      let excludedPrice = excludedItems.reduce((prev, cur)=>{ return prev + (cur.price * cur.quantity) }, 0) || 0;

      let properties = {
          cartItems: itemsHtml,
          cartTotalPrice: Shopify.formatMoney(cart.total_price, Shopify.current_money_format),
          cartTotalPriceUnformated: cart.total_price,
          cartTotalPoints: Math.ceil((cart.total_price / 10) * 0.02),
          cartSavings: this.buildCartSavings(cart),
          cartTotalPointsPriceUnformatted: cart.total_price - excludedPrice,
          cartTotalPointsPrice: Math.round(((cart.total_price - excludedPrice) / 10) * 0.02)
        };
        properties.pointsZero = (cart.total_price - excludedPrice) > 50 ? '':'0';
        
        if (window.show_free_shipping_embedded) {
          properties.shippingText = this.updateShippingText(cart);
        }

      template = template.split(/(\{\{.*?\}\})/).map((str)=>{
          if (str.indexOf('{{') !== -1){
              let key = str.replace(/\{\{|}\}/g,'').trim();
              if (properties.hasOwnProperty(key)) {
                  return properties[key];
              } else {
                return '';
              }
          }
          return str;
      }).join('');
    }

    this.appendCartHtml($holder, template);
    // iatHandler();
    !isCartPage && this.initCartDrawer(cart);
  }

  updateShippingText(cart) {
    if (window.show_free_shipping_embedded) {
      let shippingText = '';
      let shippingLimitPrice = window.free_shipping_required_price || 7500;

      if (cart.total_price < shippingLimitPrice) {
        let price = ((shippingLimitPrice - cart.total_price) / 100).toFixed(2);
        shippingText = `add $${price} to the cart for free shipping`
      } else {
        shippingText = `No Sales Tax, Free Shipping`;
      }
      // update all other shipping messages
      if ( typeof currentProduct != 'undefined' && ['nuna'].some((item)=>currentProduct.vendor.toLowerCase().indexOf(item) !== -1) ) {
        shippingText = shippingText.replace ('No Sales Tax, ', '');
      }
      document.querySelectorAll('.shipping__content .bm-shipping, .cart__info .bm-cart-text').forEach((item)=>{item.innerHTML = shippingText})
      return shippingText;
    }
  }

  /**
   * Build cart savings
   * @param  {Object} cart - The cart JSON
   * @return {String}
   */

  buildCartSavings(cart) {
    let savings = '';

    if (cart.total_discount > 0) {
      savings = Shopify.theme.locale.cart.general.savings_html.replace(
        /{{ price }}/g,
        Shopify.formatMoney(cart.total_discount, Shopify.current_money_format)
      );
    }

    return savings;
  }

  /**
   * Build cart item
   * @param  {Object}  item           - The cart item
   * @param  {Integer}  index          - Index of the cart item
   * @param  {Boolean} isCartPageItem - Is it item from the cart page
   * @return {String}                 - The item HTML
   */

  buildItem(item, index, isCartPageItem) {
    let template = isCartPageItem ? this.settings.templates.cartPageItem : this.settings.templates.cartDrawerItem;
    const itemImageSize = isCartPageItem ? this.settings.cartPage.itemImageSize : this.settings.cartDrawer.itemImageSize;
    const propertiesTemplate = isCartPageItem
      ? this.settings.templates.cartPageItemProperties
      : this.settings.templates.cartDrawerItemProperties;

    template = template.replace(
      /{{itemImageUrl}}/g,
      this.optimizeImageUrl(item.image !== null ? item.image : this.settings.noImage, itemImageSize)
    );
    template = template.replace(/{{itemUrl}}/g, item.url);
    template = template.replace(/{{itemTitle}}/g, item.product_title);
    template = template.replace(/{{itemData}}/g, JSON.stringify(item));

    if (!isCartPageItem) {
      template = template.replace(/{{itemVariants}}/g, this.buildVariantOptionsWithValues(item));
    } else {
      template = template.replace(/{{itemVariants}}/g, this.buildVariantTitle(item));
    }

    template = template.replace(/{{itemProperties}}/g, this.buildVariantProperties(item, propertiesTemplate));
    template = template.replace(/{{itemLinePrice}}/g, Shopify.formatMoney(item.line_price, Shopify.current_money_format));
    template = template.replace(/{{itemPrice}}/g, Shopify.formatMoney(item.price, Shopify.current_money_format));
    template = template.replace(/{{itemIndex}}/g, index + 1);
    template = template.replace(/{{itemKey}}/g, item.key);
    template = template.replace(/{{itemId}}/g, item.id);
    template = template.replace(/{{itemQuantity}}/g, item.quantity);

    if (item.properties !== null && item.properties['availability'] === 'In Stock') {
      template = template.replace(/{{availabilityPropertyClass}}/g, 'line-item__property--in-stock');
    } else {
      template = template.replace(/{{availabilityPropertyClass}}/g, ' ');
    }


    const inventoryQuantity = item.inventory_quantity;
    const overInventoryQuantity = item.quantity - inventoryQuantity;
    if (item.delivery_variant != null) {
      var item_delivery = item.delivery_variant;
    }
    else if (item.delivery != null)
    {
      var item_delivery = item.delivery;
    }

    if (item.quantity > item.inventory_quantity) {
      template = template.replace(/{{itemAvailability}}/g, `<span>${inventoryQuantity} in stock</span> ${overInventoryQuantity} ${item_delivery}`)
    } else {
      template = template.replace(/{{itemAvailability}}/g, '')
    }


    return template;
  }

  /**
   * Build items HTML
   * @param  {Array}  items      - The items array
   * @param  {Boolean} isCartPage
   * @return {String}             - The items HTML
   */

  buildItemsHtml(items, isCartPage) {
    let html = '';

    items.forEach((item, index) => {
      html += this.buildItem(item, index, isCartPage);
    });

    return html;
  }

  /**
   * Append items content to holder
   * @param  {jQuery Object} $holder - The holder to append items html to.
   * @param  {String} html - The items html.
   * @return {Void}
   */

  appendCartHtml($holder, html) {
    $holder[0].innerHTML = '';
    $holder[0].innerHTML = html;
  }

  /**
   * Opens the cart drawer
   * @return {void}
   */

  open() {
    if (this.isCartBuilded) {
      $(this.settings.selectors.body).addClass(this.settings.actionClasses.bodyClasses);
      $(this.settings.selectors.cartDrawer).addClass(this.settings.actionClasses.visible);
    } else {
      this.getCart();
    }
  }

  /**
   * Closes the cart drawer
   * @return {void}
   */

  close() {
    $(this.settings.selectors.body).removeClass(this.settings.actionClasses.bodyClasses);
    $(this.settings.selectors.cartDrawer).removeClass(this.settings.actionClasses.visible);
  }

  /**
   * Toggle cart drawer
   * @return {Void}
   */

  toggle() {
    this.isCartDrawerOpen = !this.isCartDrawerOpen;
    this.isCartDrawerOpen ? this.open() : this.close();
  }

  /**
   * Initialize the cart drawer upon build
   * @param  {Object} cart - The cart JSON
   * @return {Void}
   */

  initCartDrawer(cart) {
    $(this.settings.selectors.cartDrawer).toggleClass(this.settings.actionClasses.empty, !this.hasItems(cart));

    this.isCartBuilded = true;

    this.open();
  }

  /**
   * Update cart items counters
   * @param  {Integer} itemsCount - Items count
   * @return {Void}
   */

  updateCounter(itemsCount) {
    $(this.settings.selectors.cartCount)
      .toggleClass(this.settings.actionClasses.hidden, !itemsCount)
      .text(`(${itemsCount})`);
  }

  /**
   * Update the cart trigger state - has or has not items class
   * @param  {Integer} itemsCount - Cart items count
   * @return {Void}
   */

  updateCartTriggerState(itemsCount) {
    $(this.settings.selectors.cartTrigger).toggleClass(this.settings.actionClasses.hasItems, itemsCount > 0);
  }

  /**
   * Optimize image based on parameter
   * @param  {String} url       - Image url
   * @param  {String} parameter - Size of the image, for example: '_200x200'
   * @return {String}           - Optimized image URL
   */

  optimizeImageUrl(url, parameter) {
    let imageUrl = url;
    let lastDotIndex = imageUrl.lastIndexOf('.');
    imageUrl = `${imageUrl.substring(0, lastDotIndex)}_${parameter}.${imageUrl.substring(lastDotIndex + 1)}`;

    return imageUrl;
  }

  /**
   * Get cart items count
   * @param  {Object}  cart - JSON of the cart
   * @return {Boolean}      - Is cart has items
   */

  hasItems(cart) {
    return cart.item_count ? true : false;
  }

  /**
   * Get the cart items count
   * @param  {Object} cart - JSON of the cart
   * @return {Integer}     - Cart items count
   */

  getItemsCount(cart) {
    return cart.item_count;
  }

  loyaltyLionUIRefresh() {
    window.loyaltylion && window.loyaltylion.ui.refresh();
  }
}

/**
 * Assign the Cart class to the window object for global use
 */

window.Cart = new Cart();

/**
 * Double check the intention with this function as it liekly not needed
 */
function liontPoints() {
  let points = Math.ceil(cart.total_price);
  let pointsValue = points * 0.02;
  return pointsValue;
  console.log("fully loaded");
}
